<template>
  <div class="callback-container">
    <div v-if="loading" class="loading">
      <h2>正在处理微信登录...</h2>
      <div class="spinner"></div>
    </div>
    <div v-else-if="error" class="error">
      <h2>登录失败</h2>
      <p>{{ error }}</p>
      <button @click="$goToLogin($route.fullPath)">返回登录</button>
    </div>
    <div v-else class="success">
      <h2>登陆成功!!!</h2>
      <p>跳转中...</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authManager from '@/utils/auth'
import { handleGuestClaimAfterAuth, stashGuestClaimContext, readGuestClaimContext } from '@/utils/examClaim'
import { getStoredSid } from '@/utils/guestExam'
import { decodeWechatQRRedirectPath, parseWechatQRState, clearWechatSkipAutoLogin } from '@/utils/loginFlow'
import { resolvePostLoginRoute } from '@/utils/referralAuth'

function buildClaimRoute(qrState, routeQuery) {
  const ctx = readGuestClaimContext()
  const examId = String(qrState.examId || routeQuery?.examId || ctx?.examId || '')
  let sid = qrState.sid || routeQuery?.sid || ctx?.sid || ''
  if (!sid && examId) {
    sid = getStoredSid(examId) || ''
  }
  return {
    query: {
      sid,
      examId,
      href: qrState.href || routeQuery?.href || ''
    }
  }
}

export default {
  name: 'WeChatCallbackView',
  data() {
    return {
      loading: true,
      error: null
    }
  },
  async created() {
    console.log('WeChatCallbackView created')
    try {
      // Get the code and state from URL parameters
      const code = this.$route.query.code
      const state = this.$route.query.state
      const qrState = parseWechatQRState(state)
      console.log(code, state, qrState)

      if (!code) {
        const href = decodeWechatQRRedirectPath(state)
        this.$router.replace(href)
        return
      }

      if (qrState.sid && qrState.examId) {
        stashGuestClaimContext({ sid: qrState.sid, examId: qrState.examId })
      }

      const claimRoute = buildClaimRoute(qrState, this.$route.query)

      // Make the API call to get user info and JWT
      //根据当前url和域名，选择http或者https，然后拼接出完整的url

      const protocol = window.location.protocol;
      const host = window.location.host;
      const baseUrl = protocol + '//' + host
      console.log(baseUrl)
      const response = await axios.get(`${baseUrl}/api/v1/wechat/callback`, {
        params: {
          code,
          state
        }
      })
      console.log(response.data.data.accessToken)

      if (response.data?.code === 200 && response.data?.data?.accessToken) {
        console.log(response.data)
        clearWechatSkipAutoLogin()
        // Use AuthManager to handle login success
        const userInfo = await authManager.handleLoginSuccess(response.data.data)
        console.log(userInfo)
        
        this.$root.login(response.data.data)

        try {
          const claimStatus = await handleGuestClaimAfterAuth(this.$router, claimRoute)
          if (claimStatus === 'claimed' || claimStatus === 'recharge') {
            return
          }
          if (claimStatus === 'none' && claimRoute.query.sid) {
            const msg = '登录成功，但未能生成报告（答题会话可能已过期）。请返回测评页重新提交后再登录。'
            this.error = msg
            this.$message.warning(msg)
            return
          }
        } catch (claimErr) {
          const msg = claimErr.message || '生成报告失败'
          this.error = msg
          this.$message.error(msg)
          return
        }

        this.$message.success('登录成功')
        if (response.data.couponBindStatus === 'failed' && response.data.couponBindMessage) {
          this.$message.warning(`礼券绑定失败：${response.data.couponBindMessage}`)
        } else if (response.data.couponBindStatus === 'ok') {
          this.$message.success('礼券已绑定成功')
        }

        const redirectUrl = qrState.href || response.data.redirectURL || '/'
        const normalized =
          typeof redirectUrl === 'string' && redirectUrl.startsWith('/') ? redirectUrl : '/'
        const target = await resolvePostLoginRoute(normalized, {
          skipReferralForExam: normalized.startsWith('/exam/') || !!(qrState.sid && qrState.examId)
        })
        setTimeout(() => {
          if (typeof target === 'string') {
            if (target.startsWith('/')) {
              this.$router.replace(target)
            } else {
              window.location.href = target
            }
          } else {
            this.$router.replace(target)
          }
        }, 500)
      } else {
        throw new Error('Invalid response from server')
      }
    } catch (err) {
      console.error('WeChat callback error:', err)
      this.error = err.message || 'An error occurred during login'
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.callback-container {
  max-width: 600px;
  margin: 100px auto;
  padding: 20px;
  text-align: center;
}

.loading, .error, .success {
  padding: 20px;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 20px auto;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error {
  color: #dc3545;
}

.error button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.error button:hover {
  background-color: #c82333;
}

.success {
  color: #28a745;
}
</style> 